import React from 'react';
import { Hexagon, Linkedin, Twitter } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-950 text-slate-400 py-16 border-t border-navy-800" data-id="element-23">
      <div className="container mx-auto px-6 max-w-7xl" data-id="element-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-25">
          <div className="col-span-1 md:col-span-2" data-id="element-26">
            <a href="#" className="flex items-center gap-2 mb-6" data-id="element-27">
              <div className="relative flex items-center justify-center w-6 h-6" data-id="element-28">
                <Hexagon className="absolute w-full h-full text-white stroke-[2]" data-id="element-29" />
                <div className="w-1.5 h-1.5 bg-white rounded-sm rotate-45" data-id="element-30"></div>
              </div>
              <span className="font-heading font-bold text-lg text-white tracking-wide" data-id="element-31">
                Portalplay.
              </span>
            </a>
            <p className="text-sm max-w-md mb-8 leading-relaxed" data-id="element-32">
              B2B content marketing architecture for tech and SaaS companies. We
              engineer content strategies that drive measurable pipeline and
              revenue.
            </p>
            <div className="flex gap-4" data-id="element-33">
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-navy-800 hover:bg-navy-800 hover:text-white transition-colors" data-id="element-34">
                <Linkedin size={18} data-id="element-35" />
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center border border-navy-800 hover:bg-navy-800 hover:text-white transition-colors" data-id="element-36">
                <Twitter size={18} data-id="element-37" />
              </a>
            </div>
          </div>

          <div data-id="element-38">
            <h4 className="font-heading font-semibold text-white mb-6 uppercase tracking-wider text-xs" data-id="element-39">
              Navigation
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-40">
              <li data-id="element-41">
                <a href="#solutions" className="hover:text-white transition-colors" data-id="element-42">
                  Solutions
                </a>
              </li>
              <li data-id="element-43">
                <a href="#process" className="hover:text-white transition-colors" data-id="element-44">
                  Process
                </a>
              </li>
              <li data-id="element-45">
                <a href="#results" className="hover:text-white transition-colors" data-id="element-46">
                  Results
                </a>
              </li>
              <li data-id="element-47">
                <a href="#pricing" className="hover:text-white transition-colors" data-id="element-48">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-49">
            <h4 className="font-heading font-semibold text-white mb-6 uppercase tracking-wider text-xs" data-id="element-50">
              Headquarters
            </h4>
            <address className="not-italic text-sm space-y-1" data-id="element-51">
              <p data-id="element-52">Limassol</p>
              <p data-id="element-53">Cyprus</p>
            </address>
            <div className="mt-6 w-12 h-12 border border-navy-800 flex items-center justify-center opacity-50" data-id="element-54">
              <div className="w-4 h-4 bg-navy-800 clip-triangle" data-id="element-55"></div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-navy-800 flex flex-col md:flex-row justify-between items-center gap-4 text-xs" data-id="element-56">
          <p data-id="element-57">© 2026 Portalplay. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-58">
            <a href="#" className="hover:text-white transition-colors" data-id="element-59">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-60">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}